(function () {
  var R = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  function drawer() { return $('[data-drawer]'); }
  function openCart() { var d = drawer(); if (!d) return; d.classList.add('on'); d.setAttribute('aria-hidden', 'false'); var o = $('.ov'); if (o) o.classList.add('on'); }
  function closeCart() { var d = drawer(); if (!d) return; d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); var o = $('.ov'); if (o) o.classList.remove('on'); }
  function setCount(n) { document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = $('.drawer-inner', doc), old = $('.drawer-inner');
    if (fresh && old) { old.replaceWith(fresh); setCount(fresh.getAttribute('data-count')); }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart],[data-close-cart],[data-qty],[data-menu],[data-thumb]');
    if (!t) return;
    if (t.hasAttribute('data-open-cart')) { e.preventDefault(); openCart(); }
    else if (t.hasAttribute('data-close-cart')) { closeCart(); }
    else if (t.hasAttribute('data-menu')) {
      var nav = $('[data-nav]'); var o = nav.classList.toggle('open'); t.setAttribute('aria-expanded', o);
    } else if (t.hasAttribute('data-thumb')) {
      var img = $('[data-main-image] img');
      if (img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = t.getAttribute('data-thumb'); }
    } else if (t.hasAttribute('data-qty')) {
      fetch(R + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: +t.getAttribute('data-line'), quantity: +t.getAttribute('data-to'), sections: 'cart-drawer' })
      }).then(function (r) { return r.json(); }).then(function (j) { if (j.sections) swap(j.sections['cart-drawer']); });
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-add-form]')) return;
    // "Buy Now" button sends return_to=/checkout and goes straight to Shopify checkout
    if (e.submitter && e.submitter.name === 'return_to') return;
    e.preventDefault();
    var fd = new FormData(f); fd.append('sections', 'cart-drawer');
    var btn = e.submitter; if (btn) btn.disabled = true;
    fetch(R + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status) { alert(j.description || j.message || 'Error'); return; }
        if (j.sections) swap(j.sections['cart-drawer']);
        openCart();
      }).catch(function () { f.submit(); })
      .then(function () { if (btn) btn.disabled = false; });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
})();
